'use client';

import { awsExports } from '@/services/config';
import { Amplify } from 'aws-amplify';

Amplify.configure(
  {
    API: {
      REST: awsExports.aws_cloud_logic_custom.reduce((acc: { [key: string]: any }, curr) => {
        acc[curr.name] = {
          endpoint: curr.endpoint,
          region: curr.region,
        };
        return acc;
      }, {}),
    },
    Auth: {
      Cognito: {
        userPoolClientId: awsExports.aws_user_pools_web_client_id,
        userPoolId: awsExports.aws_user_pools_id,
        identityPoolId: awsExports.aws_cognito_identity_pool_id,
        loginWith: {
          oauth: awsExports.oauth,
          phone: true,
          email: true,
        },
      },
    },
  },
  { ssr: true }
);

export default function AmplifyConfigurator() {
  return null;
}
